import React, {
    ReactElement, ReactNode,
} from "react";
import Styles from "./Contacts.module.scss";
import Organizations from "../../components/contacts/Organizations";
import useRouting, { Link, PathMatchType, useParams } from "../../contexts/Routing";
import Users from "../../components/contacts/Users";

interface Section {
    title?: string;
    name?: string;
    slug: string;
    page?: () => ReactElement;
    url?: string
}
interface Category {
    name: string;
    sections: Section[]
}

interface ContactsProps {
    children?: ReactNode;
    title?: string;
}

const SECTIONS: Category[] = [
    {
        name: "Contacts",
        sections: [
            {
                name: "Users",
                title: "Users",
                slug: "users",
                page: Users,
            },
            {
                name: "Organizations",
                title: "Organizations",
                slug: "organizations",
                page: Organizations,
            },
        ],
    },

];

const DEFAULT = SECTIONS[0].sections[0];
const FLAT_SECTIONS = SECTIONS.flatMap(row => row.sections);

export default function Contacts(props: ContactsProps): ReactElement {
    const { Paths, historyPush } = useRouting();

    const { entity } = useParams(Paths.CONTACTS_ENTITY, PathMatchType.PARTIAL_PATH);

    if (!entity) {
        historyPush(Paths.CONTACTS_ENTITY, { entity: DEFAULT.slug });
    }

    const container = entity ? FLAT_SECTIONS.find(page => page.slug === entity) : undefined;
    const Page = container ? container.page : undefined;

    return (

        <div className="d-flex justify-content-between align-items-stretch h-100">
            <div className={`overflow-hidden flex-shrink-0 ${Styles.sidebar}`}>
                <div className="position-sticky">
                    <div className="text-center pt-3 pb-2">
                        <h4 className="text-gray-500">Contacts</h4>
                    </div>
                    {SECTIONS.map(group => (
                        <div key={group.name}>
                            <div className="" role="tablist">
                                {group.sections.filter(section => section.name).map(section => (

                                    <Link
                                        key={section.slug}
                                        to={Paths.CONTACTS_ENTITY}
                                        params={{ entity: section.slug }}
                                        className={`list-group-item list-group-item-action border-start d-flex `
                                            + ` list-border ${container?.slug === section.slug
                                                ? "fw-semibold list-border-primary " : ""}`
                                            + ` rounded-0  align-items-center mb-1`}
                                    >
                                        {section.name}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            <div className="flex-grow-1 p-3 d-flex flex-column shadow">
                {(container?.title || props.title) && (
                    <h5 className="mb-3 mt-2">
                        {props.title ?? container?.title}
                    </h5>
                )}

                {props.children ? props.children : Page && <Page />}

            </div>

        </div>

    );
}

Contacts.defaultProps = {
    children: undefined,
    title: undefined,
};
